import { render } from "./config_io_icons.vue?vue&type=template&id=48b524f4&scoped=true"
import script from "./config_io_icons.vue?vue&type=script&lang=js"
export * from "./config_io_icons.vue?vue&type=script&lang=js"

import "./config_io_icons.vue?vue&type=style&index=0&id=48b524f4&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\horva\\Documents\\nodejs\\production\\enat05\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b524f4"]])

export default __exports__